import { derived } from 'overmind'
import { State } from './types'

export const state: State = {
  shouldLoadRates: derived((state: State) => state.subscriptionPool.length > 0),
  subscriptionPool: [],
  data: [],
}
